import { acceptHMRUpdate, defineStore } from 'pinia';
import { readonly, ref } from 'vue';
import { i18n } from '@/plugins/i18n';
import { fetchReceivers, Receiver } from '@/services/receivers';

const { t } = i18n.global;

export type ReceiverStore = Receiver & { address: string };

export const useReceiversStore = defineStore('receivers', () => {
  const receivers = ref<ReceiverStore[]>([]);

  const fetchReceiversWithCache = async () => {
    const receiversFromServer = await fetchReceivers();

    receivers.value = receiversFromServer.map((receiver) => {
      const address =
        !receiver.neighborhood || !receiver.city ? '' : t('address.default', receiver);

      return { ...receiver, address };
    });
  };

  return {
    receivers: readonly(receivers),
    fetchReceiversWithCache,
  };
});

if (import.meta.hot) {
  import.meta.hot.accept(acceptHMRUpdate(useReceiversStore, import.meta.hot));
}
